import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Box} from '@buncha/components/core/view';
import {H6Text} from '@buncha/components/core/text';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import {PButton} from '@buncha/components/core/Button';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

interface DriverBarCodeEducationBodyProps {
  onPress: () => void;
}
const DriverBarCodeEducationBody: React.FC<
  DriverBarCodeEducationBodyProps
> = props => {
  const muli = useFontTheme('muli');
  const theme = useColorThemeType('main');
  const {body, button} =
    useGetLocale(Modules.aboutShift, HomeScreens.AboutShift) ?? {};
  const navigateToVanLoadScreen = useCallback(() => {
    props?.onPress();
  }, [props]);
  return (
    <Box style={styles.parentBox}>
      <Box>
        <H6Text
          style={[
            styles.bodyText,
            {fontFamily: muli?.[700]?.normal, color: theme?.text?.gray?.[100]},
          ]}>
          {body?.printer?.step1}
        </H6Text>
        <H6Text
          style={[
            styles.bodyText,
            {fontFamily: muli?.[700]?.normal, color: theme?.text?.gray?.[100]},
          ]}>
          {body?.printer?.step2}
        </H6Text>
        <H6Text
          style={[
            styles.bodyText,
            {fontFamily: muli?.[700]?.normal, color: theme?.text?.gray?.[100]},
          ]}>
          {body?.printer?.step3}
        </H6Text>
      </Box>
      <PButton
        onPress={navigateToVanLoadScreen}
        title={button?.proceed}
        style={styles.buttonStyle}
      />
    </Box>
  );
};

export default React.memo(DriverBarCodeEducationBody);

const styles = StyleSheet.create({
  parentBox: {
    gap: 20,
  },
  bodyText: {
    textAlign: 'left',
  },
  buttonStyle: {
    borderRadius: 100,
  },
});
